
export default class generalTools{
    getWeek(date) {
        let firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        let daysOffset = (date.getDay() + 6) % 7;
        let firstMonday = new Date(firstDayOfYear.setDate(firstDayOfYear.getDate() - firstDayOfYear.getDay() + 1));
        let currentDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        let weekNumber = Math.ceil((((currentDay - firstMonday) / 86400000) + 1 + daysOffset) / 7);
    
        return weekNumber;
    }

    someWeekAtivity(activitys) {
        if(!Array.isArray(activitys)) return false;
        
        for (let i = 0; i < activitys.length; i++) {
            let semana  = activitys[i].semana;
            for (let j = 0; j < semana.length; j++) {
               let cantidad = semana[j].cantidad;
               if(typeof cantidad == 'string' && cantidad != "")  cantidad = parseInt(cantidad);
               if(cantidad != "" && cantidad>0) return true;
            }
        }
        return false;
    }

    getActiveAtivitys(activitys) {
        if(!Array.isArray(activitys)) return [];
        let realActiv = [];
        
        for (let i = 0; i < activitys.length; i++) {
            let semana  = activitys[i].semana;
            let activ = false;
            for (let j = 0; j < semana.length; j++) {
               let cantidad = semana[j].cantidad;
               if(typeof cantidad == 'string' && cantidad != "")  cantidad = parseInt(cantidad);
               if(cantidad != "" && cantidad>0){ 
                    activ = true;
                    j = 999999999999999;
                }
            }
            if(activ) realActiv.push(activitys[i]);
        }
        return realActiv;
    }

    static formatDate(dateString) {
        if(!dateString || typeof dateString != 'string' || dateString.length < 10) return 'No disponible';
        // Obtener los valores de año, mes y día de la cadena
        const year = dateString.substring(0, 4);
        const month = dateString.substring(5, 7);
        const day = dateString.substring(8, 10);
        // Crear un objeto de fecha utilizando los valores extraídos
        const date = new Date(year, month - 1, day);
      
        // Definir los nombres de los meses
        const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      
        // Obtener el nombre del día y del mes utilizando los índices de los arrays
        const monthName = months[date.getMonth()];
      
        // Construir la cadena formateada
        const formattedDate = `${day} ${monthName} ${year}`;
      
        return formattedDate;
      }
    
      static formatDateTime(dateString) {
        if(!dateString || typeof dateString != 'string' || dateString.length < 10) return 'No disponible';
        // Obtener los valores de año, mes y día de la cadena
        const year = dateString.substring(0, 4);
        const month = dateString.substring(5, 7);
        const day = dateString.substring(8, 10);
        const hour = dateString.substring(11, 16);
        // Crear un objeto de fecha utilizando los valores extraídos
        const date = new Date(year, month - 1, day);
      
        // Definir los nombres de los meses
        const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      
        // Obtener el nombre del día y del mes utilizando los índices de los arrays
        const monthName = months[date.getMonth()];
      
        // Construir la cadena formateada
        const formattedDate = `${day} ${monthName} ${year} (${hour})`;
      
        return formattedDate;
      }
}

